<div [ngClass]="{ 'focused': isOpen, 'has-shadow': boxShadow, 'gray': gray }" nhaTest="nha-search-box" class="nha-search-box">
	@if (lockOpen) {
		<mat-icon class="search-icon dense-2">search</mat-icon>
	} @else {
		<button mat-icon-button class="search dense-2" nhaTest="nha-search-button" (click)="toggleVisibility()">
			<mat-icon>search</mat-icon>
		</button>
	}
	@if (isOpen) {
		<input
			matInput
			type="text"
			#searchInput
			[formControl]="searchTerm"
			[placeholder]="placeholder"
			(focus)="onInputFocus()"
			(blur)="onInputBlur()"
			nhaTest="nha-search-input"
			[style.min-width]="minWidth"
			name="nhaSearch"
			autocomplete="off"
			data-lpignore="true"
			data-1p-ignore
			data-form-type="other"
		/>
	}
	@if (isOpen && showClearButton) {
		<button mat-icon-button class="search dense-2" nhaTest="nha-clear-search" (click)="clear()">
			<mat-icon>close</mat-icon>
		</button>
	}
</div>
